import React, { FC, useMemo, useState } from 'react';
import dayjs from 'dayjs';
import { TimeRangePickerProps } from 'antd';

// Shared UI Library Components
import { CustomIcon, DatePickerElement, EIconName } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './month-slider.scss';

type TMonthSliderProps = {
  companyCreated: string;
  changeDate?: (date: string) => void;
};

export const MonthSlider: FC<TMonthSliderProps> = (
  { companyCreated, changeDate = () => {} }: TMonthSliderProps
) => {

  const [currentDate, setCurrentDate] = useState<dayjs.Dayjs>(dayjs());
  const [openDatePicker, setOpenDatePicker] = useState<boolean>(false);

  const disabledPrevAction: boolean = useMemo(() => currentDate.isSame(dayjs(companyCreated), 'month'), [currentDate]);
  const disabledNextAction: boolean = useMemo(() => currentDate.isSame(dayjs(), 'month'), [currentDate]);

  const disabledDate: TimeRangePickerProps['disabledDate'] = (current) => {
    // Can not select months before company created_at
    return current < dayjs(companyCreated).startOf('month') || current > dayjs().endOf('month');
  };

  const onChangeMonth = (action: 'subtract' | 'add'): void => {
    if ((action === 'subtract' && disabledPrevAction) || (action === 'add' && disabledNextAction)) return;
    setCurrentDate(currentDate[action](1, 'month'));
    changeDate(currentDate[action](1, 'month').format('YYYY-MM-DD'));
  }

  const onDatePickerChange = (value: any, _: any): void => {
    if (!value) return;
    setCurrentDate(value);
    changeDate(value.format('YYYY-MM-DD'));
  }

  const onOpenDatePicker = (): void => {
    setOpenDatePicker(!openDatePicker);
  }

  return (
    <div className="month-slider">

      <div className={ `month-slider--prev ${ disabledPrevAction ? 'disabled-action' : '' }` }>
        <CustomIcon name={ EIconName.ArrowDown } onClick={ () => onChangeMonth('subtract') }/>
      </div>

      <div className="month-slider--view">
        <div className="view-text" onClick={ onOpenDatePicker }>{ dayjs(currentDate).format('MMMM YYYY') }</div>

        <DatePickerElement
          value={ currentDate }
          placement={ 'bottomLeft' }
          disabledDate={ disabledDate }
          open={ openDatePicker }
          picker={ 'month' }
          onOpenChange={ open => setOpenDatePicker(open) }
          onChange={ onDatePickerChange }
          allowClear={ { clearIcon: false } }
        />
      </div>

      <div className={ `month-slider--next ${ disabledNextAction ? 'disabled-action' : '' }` }>
        <CustomIcon name={ EIconName.ArrowDown } onClick={ () => onChangeMonth('add') }/>
      </div>
    </div>
  );
}
